const baseTitle =
  'IT/Webエンジニアの転職・求人サイトFindy – GitHubからスキル偏差値を算出';

/**
 * ページタイトルを生成する
 * @param pageTitle ページタイトル。指定しない場合は共通文言のみを含んだタイトルを生成する
 *
 * @example
 * ```
 * generateTitle()
 * // => 'IT/Webエンジニアの転職・求人サイトFindy – GitHubからスキル偏差値を算出'
 * generateTitle('プロフィール')
 * // => 'プロフィール | IT/Webエンジニアの転職・求人サイトFindy – GitHubからスキル偏差値を算出'
 * ```
 */
export const generateTitle = (pageTitle?: string): string => {
  const title = pageTitle ? `${pageTitle} | ${baseTitle}` : baseTitle;

  return title;
};
